import TranslationService from "../../services/TranslationService";
import Vue from "vue";

const ModalService = require("../../services/ModalService");
const ApiService = require("../../services/ApiService");
const NotificationService = require("../../services/NotificationService");

export default Vue.component("order-confirmation-phone", {

    props:
    {
        template:
        {
            type: String,
            default: "#vue-order-confirmation-phone"
        },
        orderId:
        {
            type: [Number, String],
            default: 0
        },
        accessKey:
        {
            type: String,
            default: ""
        },
        phone:
        {
            type: String,
            default: ""
        },
        deliveryAddress:
        {
            type: [Object, Array],
            default: null
        },
        billingAddress:
        {
            type: [Object, Array],
            default: null
        }
    },

    data()
    {
        // A number on EITHER address is sufficient (rule: one is enough): show the
        // delivery number if present, otherwise the billing number; fall back to the
        // plain `phone` prop. Reading from the passed address json is reliable, unlike
        // deep relation access in the widget twig.
        const initialPhone = this.getAddressTelephone(this.deliveryAddress)
            || this.getAddressTelephone(this.billingAddress)
            || (this.phone || "");

        return {
            phoneModal: {},
            phoneInput: "",
            currentPhone: initialPhone,
            isPending: false
        };
    },

    computed:
    {
        isShopBuilder()
        {
            return typeof App !== "undefined" && !!App.isShopBuilder;
        }
    },

    methods:
    {
        // Read the telephone (option typeId 4) from a passed address json, '' if none.
        getAddressTelephone(address)
        {
            if (address && Array.isArray(address.options))
            {
                const option = address.options.find(opt => parseInt(opt.typeId, 10) === 4);

                if (option && option.value)
                {
                    return "" + option.value;
                }
            }

            return "";
        },

        getUrlParam(name)
        {
            const match = window.location.search.match(new RegExp("[?&]" + name + "=([^&]*)"));

            return match ? decodeURIComponent(match[1].replace(/\+/g, " ")) : "";
        },

        resolveOrderId()
        {
            return this.orderId && parseInt(this.orderId, 10) > 0 ? this.orderId : this.getUrlParam("orderId");
        },

        resolveAccessKey()
        {
            return this.accessKey ? this.accessKey : this.getUrlParam("accessKey");
        },

        openModal()
        {
            this.phoneInput = this.currentPhone;
            this.phoneModal = ModalService.findModal(this.$refs.confirmationPhoneModal);
            this.phoneModal.show();
        },

        closeModal()
        {
            if (this.phoneModal && this.phoneModal.hide)
            {
                this.phoneModal.hide();
            }

            this.isPending = false;
        },

        savePhoneNumber()
        {
            const phone = this.phoneInput ? this.phoneInput.trim() : "";

            if (phone.length <= 0 || this.isPending)
            {
                return;
            }

            this.isPending = true;

            ApiService.post(
                "/rest/ceres/order/delivery-phone",
                { orderId: this.resolveOrderId(), accessKey: this.resolveAccessKey(), telephone: phone },
                { supressNotifications: true }
            )
                .done(() =>
                {
                    this.currentPhone = phone;
                    this.closeModal();
                })
                .fail(() =>
                {
                    this.isPending = false;
                    NotificationService.error(
                        TranslationService.translate("Ceres::Template.confirmationPhoneSaveError")
                    );
                });
        }
    }
});
